import script from "./page-not-found.vue?vue&type=script&setup=true&lang=js"
export * from "./page-not-found.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__